<template>
    <div class="facilities knowledge-base">
        <knowledge-nav />

        <div class="facilities__heading knowledge-base__heading">

            <svg width="883" height="109" viewBox="0 0 883 109" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M28.916 78.6367V118.195H0.808594V1.60156H47.334C56.2493 1.60156 64.1237 3.25651 70.957 6.56641C77.8438 9.82292 83.1556 14.4941 86.8926 20.5801C90.6829 26.6126 92.5781 33.4727 92.5781 41.1602C92.5781 52.5312 88.4941 61.6335 80.3262 68.4668C72.2116 75.2467 61.054 78.6367 46.8535 78.6367H28.916ZM28.916 56.9355H47.334C52.7793 56.9355 56.9167 55.5742 59.7461 52.8516C62.6289 50.1289 64.0703 46.2852 64.0703 41.3203C64.0703 35.875 62.6022 31.5241 59.666 28.2676C56.7298 25.0111 52.7259 23.3561 47.6543 23.3027H28.916V56.9355Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M150.955 77.0352H135.74V118.195H107.633V1.60156H153.518C167.344 1.60156 178.155 4.67122 185.949 10.8105C193.743 16.9499 197.641 25.625 197.641 36.8359C197.641 44.9505 195.986 51.6771 192.676 57.0156C189.419 62.3542 184.294 66.6784 177.301 69.9883L201.645 116.994V118.195H171.535L150.955 77.0352ZM135.74 55.334H153.518C158.856 55.334 162.86 53.946 165.529 51.1699C168.252 48.3405 169.613 44.4167 169.613 39.3984C169.613 34.3802 168.252 30.4564 165.529 27.627C162.807 24.7441 158.803 23.3027 153.518 23.3027H135.74V55.334Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M263.465 128.205H244.326L284.125 1.60156H303.344L263.465 128.205Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M382.061 78.6367V118.195H353.953V1.60156H400.479C409.394 1.60156 417.268 3.25651 424.102 6.56641C430.988 9.82292 436.3 14.4941 440.037 20.5801C443.827 26.6126 445.723 33.4727 445.723 41.1602C445.723 52.5312 441.639 61.6335 433.471 68.4668C425.356 75.2467 414.199 78.6367 399.998 78.6367H382.061ZM382.061 56.9355H400.479C405.924 56.9355 410.061 55.5742 412.891 52.8516C415.773 50.1289 417.215 46.2852 417.215 41.3203C417.215 35.875 415.747 31.5241 412.811 28.2676C409.874 25.0111 405.87 23.3561 400.799 23.3027H382.061V56.9355Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M558.232 118.195H530.285V69.5078H488.885V118.195H460.777V1.60156H488.885V47.8867H530.285V1.60156H558.232V118.195Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M674.826 62.3008C674.826 73.6719 672.717 83.735 668.5 92.4902C664.283 101.245 658.277 107.999 650.482 112.75C642.742 117.448 633.906 119.797 623.977 119.797C614.047 119.797 605.238 117.528 597.551 112.99C589.863 108.399 583.857 101.859 579.533 93.3711C575.262 84.8828 573.02 75.14 572.807 64.1426V57.5762C572.807 46.1517 574.889 36.0885 579.053 27.3867C583.27 18.6315 589.276 11.8783 597.07 7.12695C604.918 2.37565 613.833 0 623.816 0C633.693 0 642.501 2.34896 650.242 7.04688C657.983 11.7448 663.989 18.4447 668.26 27.1465C672.584 35.7949 674.773 45.7246 674.826 56.9355V62.3008ZM646.238 57.416C646.238 45.8314 644.29 37.0495 640.393 31.0703C636.549 25.0378 631.023 22.0215 623.816 22.0215C609.723 22.0215 602.275 32.5918 601.475 53.7324L601.395 62.3008C601.395 73.7253 603.29 82.5072 607.08 88.6465C610.87 94.7858 616.503 97.8555 623.977 97.8555C631.077 97.8555 636.549 94.8392 640.393 88.8066C644.236 82.7741 646.185 74.099 646.238 62.7812V57.416Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M773.963 23.3027H738.969V118.195H710.861V23.3027H676.508V1.60156H773.963V23.3027Z" fill="#F0F5FD" fill-opacity="0.1"/>
                <path d="M882.389 62.3008C882.389 73.6719 880.28 83.735 876.062 92.4902C871.845 101.245 865.839 107.999 858.045 112.75C850.304 117.448 841.469 119.797 831.539 119.797C821.609 119.797 812.801 117.528 805.113 112.99C797.426 108.399 791.42 101.859 787.096 93.3711C782.825 84.8828 780.583 75.14 780.369 64.1426V57.5762C780.369 46.1517 782.451 36.0885 786.615 27.3867C790.833 18.6315 796.839 11.8783 804.633 7.12695C812.48 2.37565 821.396 0 831.379 0C841.255 0 850.064 2.34896 857.805 7.04688C865.546 11.7448 871.551 18.4447 875.822 27.1465C880.146 35.7949 882.335 45.7246 882.389 56.9355V62.3008ZM853.801 57.416C853.801 45.8314 851.852 37.0495 847.955 31.0703C844.111 25.0378 838.586 22.0215 831.379 22.0215C817.285 22.0215 809.838 32.5918 809.037 53.7324L808.957 62.3008C808.957 73.7253 810.852 82.5072 814.643 88.6465C818.433 94.7858 824.065 97.8555 831.539 97.8555C838.639 97.8555 844.111 94.8392 847.955 88.8066C851.799 82.7741 853.747 74.099 853.801 62.7812V57.416Z" fill="#F0F5FD" fill-opacity="0.1"/>
            </svg>


            <div class="facilities__heading-title knowledge-base__heading-title">
                {{$store.getters.t('facilities_store_form_pr')}} & {{$store.getters.t('facilities_store_form_photo_help')}}
            </div>

        </div>


        <div class="facilities__grid knowledge-base__grid">
            <div class="container">
                <div class="row">
                    <div class="col-md-12 col-lg-3">
                        <aside class="sidebar product--sidebar" @click="filterToggle">

                            <div class="product--sidebar-wrapper">

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse1" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse1">
                                        <h4>{{$store.getters.t('facilities_filter_location')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse1">
                                        <div class="card-content">
                                            <div class="form-group mt-2">
                                                <label for="city_id">{{$store.getters.t('donors_locality')}}</label>
                                                <div class="" style="position:relative;">
                                                    <input v-model="locationSearch" class="form-control city-filter" autocomplete="off" id="city_id" :placeholder="$store.getters.t('donors_start_typing_locality')"/>
                                                    <div class="search-result" v-if="locationItems.length">
                                                        <div class="city-item" v-for="location in locationItems" @click="setCityId(location)">{{location.name}}</div>
                                                    </div>
                                                    <div class="search-result" v-if="!locationItems.length && locationSearch && locationSearch !== locationSelected">
                                                        <div class="city-item">{{$store.getters.t('facilities_store_form_nothing_found')}}</div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse2" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse2">
                                        <h4>{{$store.getters.t('facilities_filter_tariff')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse2">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'paid_for'"
                                                           @change="dynamicFilter('chargeCategory','paid_for', $event)" id="filter_paid" class="">
                                                    <label for="filter_paid">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_paid')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'free'"
                                                           @change="dynamicFilter('chargeCategory','free', $event)" id="filter_free" class="">
                                                    <label for="filter_free">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_free')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="chargeCategory === 'cost_recovery'"
                                                           @change="dynamicFilter('chargeCategory','cost_recovery', $event)" id="filter_cost_recovery" class="">
                                                    <label for="filter_cost_recovery">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_cost_recovery')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse3" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse3">
                                        <h4>{{$store.getters.t('facilities_store_form_availability')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse3">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'city'"
                                                           @change="dynamicFilter('range','city', $event)" id="range_filter_city" class="">
                                                    <label for="range_filter_city">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_city')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'region'"
                                                           @change="dynamicFilter('range','region', $event)" id="range_filter_region" class="">
                                                    <label for="range_filter_region">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_region')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'country'"
                                                           @change="dynamicFilter('range','country', $event)" id="range_filter_country" class="">
                                                    <label for="range_filter_country">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_country')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           :checked="range === 'abroads'"
                                                           @change="dynamicFilter('range','abroads', $event)" id="range_filter_abroads" class="">
                                                    <label for="range_filter_abroads">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_abroad')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                                <div class="sidebar-card card--slider">
                                    <a class="card-title" href="#collapse4" role="button" data-toggle="collapse" aria-expanded="false" aria-controls="collapse4">
                                        <h4>{{$store.getters.t('facilities_store_form_service_type')}}
                                            <span class="lnr lnr-chevron-down"></span>
                                        </h4>
                                    </a>
                                    <div class="collapse show collapsible-content" id="collapse4">
                                        <ul class="card-content">
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           v-model="types" value="photo_help"
                                                           id="filter_photo_help" class="">
                                                    <label for="filter_photo_help">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_photo_help')}}
                                                    </label>
                                                </div>
                                            </li>
                                            <li>
                                                <div class="custom-checkbox2">
                                                    <input type="checkbox"
                                                           v-model="types" value="pr_help"
                                                           id="filter_pr_help" class="">
                                                    <label for="filter_pr_help">
                                                        <span class="square"></span>{{$store.getters.t('facilities_store_form_pr')}}
                                                    </label>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>

                            </div>


                            <button id="sidebar-toggle" @click.prevent="sidebarFilterToggle">

                                <svg width="23" height="15" viewBox="0 0 23 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0 0.882353C0 0.395037 0.466882 0 1.04278 0H21.8984C22.4743 0 22.9412 0.395037 22.9412 0.882353C22.9412 1.36967 22.4743 1.76471 21.8984 1.76471H1.04278C0.466882 1.76471 0 1.36967 0 0.882353Z" fill="white"/>
                                    <path d="M7.05884 9.7059C7.05884 9.21859 7.36273 8.82355 7.73757 8.82355H15.2036C15.5785 8.82355 15.8824 9.21859 15.8824 9.7059C15.8824 10.1932 15.5785 10.5883 15.2036 10.5883H7.73757C7.36273 10.5883 7.05884 10.1932 7.05884 9.7059Z" fill="white"/>
                                    <path d="M4.41187 5.2941C4.41187 4.80679 4.89809 4.41174 5.49784 4.41174H17.4435C18.0433 4.41174 18.5295 4.80679 18.5295 5.2941C18.5295 5.7814 18.0433 6.17645 17.4435 6.17645H5.49784C4.89809 6.17645 4.41187 5.7814 4.41187 5.2941Z" fill="white"/>
                                    <path d="M9.88229 13.2353C9.29761 13.2353 8.82349 13.6303 8.82349 14.1176C8.82349 14.605 9.29761 15 9.88229 15H13.0588C13.6435 15 14.1176 14.605 14.1176 14.1176C14.1176 13.6303 13.6435 13.2353 13.0588 13.2353H9.88229Z" fill="white"/>
                                </svg>


                            </button>


                        </aside>
                    </div>

                    <div class="col-md-12 col-lg-9">


                        <div class="facilities__store knowledge-base__store">

                            <a href="/auth/login" class="btn auto-help__store-btn knowledge-base__store-btn" v-if="!user">
                                {{$store.getters.t('facilities_add_ad')}}
                            </a>

                            <button class="btn facilities__store-btn knowledge-base__store-btn" v-else @click.prevent="showStoreForm = !showStoreForm">
                                {{$store.getters.t('facilities_add_ad')}}
                            </button>

                            <transition name="slide">
                                <store-form @storeForm="refreshList" page-type="photo-n-pr" type="STORE" v-show="showStoreForm"/>
                            </transition>

                        </div>

                        <template v-if="!loaded">
                            <div class="facilities__item knowledge-base__item knowledge-base__item--empty d-flex">
                                <div class="LoaderBalls">
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                    <div class="LoaderBalls__item"></div>
                                </div>
                            </div>
                        </template>
                        <template v-else>


                            <div v-if="list.length">
                                <div class="facilities__item" v-for="(item, idx) in list">
                                    <card-horizontal @deleted="getFacilities" :facility="item" :index="idx" :pets="userPets" :projects="userProjects" :key="idx" :user="user"/>
                                </div>

                                <div class="row" v-if="pageCount > 1">
                                    <div class="col-md-12">
                                        <div class="pagination-area pull-right">
                                            <nav class="navigation pagination" role="navigation">
                                                <div class="nav-links">
                                                    <paginate
                                                        v-model="page"
                                                        :page-count="pageCount"
                                                        :click-handler="paginateClickCallback"
                                                        :prev-text="''"
                                                        :next-text="''"
                                                        :container-class="'className'"
                                                        :page-class="'page-numbers'"
                                                        :page-link-class="''"
                                                        :active-class="'current'"
                                                        :prev-class="'prev page-numbers'"
                                                        :prev-link-class="'lnr lnr-arrow-left'"
                                                        :next-class="'next page-numbers'"
                                                        :next-link-class="'lnr lnr-arrow-right'"
                                                    >
                                                    </paginate>
                                                </div>
                                            </nav>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div v-else>
                                <div class="facilities__item knowledge-base__item knowledge-base__item--empty d-flex">
                                    {{$store.getters.t('facilities_list_empty')}}
                                </div>
                            </div>

                        </template>
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>

import {paginationScrollTo} from '../helpers/helpers'


import KnowledgeNav from "../KnowledgeBase/KnowledgeNav";
import CardHorizontal from "./CardHorizontal";
import StoreForm from "./StoreForm";


export default {
    name: "Facilities",
    props: ['facilitiesData'],
    components:{
        KnowledgeNav,
        CardHorizontal,
        StoreForm
    },
    data(){
        return{
            showStoreForm: false,
            list: [],
            page: 1,
            pageCount: 0,
            userPets: [],
            userProjects: [],
            loaded: true,

            searchBy: null,

            locationSearch: null,
            locationSelected: null,
            selectedLocationId: null,
            locationItems: [],

            chargeCategory: null,
            range: null,
            types: [],

            standardTypes: ['photo_help', 'pr_help']


        }
    },
    mounted(){
        this.loaded = false
        this.getUserPetsAndProdjects()
        this.getUserPetsAndProdjects('projects')
        this.getFacilities()

    },

    watch:{
        list(){
            this.loaded = false
            setTimeout(()=>{
                this.loaded = true
            }, 1000)
        },

        locationSearch(value) {
            if (!value) {
                this.locationSelected = null;
                this.searchBy = null;
                this.locationItems = [];
                this.selectedLocationId = null;
                return false;
            }

            if (value !== this.locationSelected) {
                this.searchLocations();
            }
        },

        selectedLocationId() {
            this.getFacilities(true);
        },

        chargeCategory() {
            this.getFacilities(true);
        },

        range() {
            this.getFacilities(true);
        },

        types() {
            this.getFacilities(true);
        },


    },

    computed:{
        user(){
            return this.$store.getters.getUserData
        }
    },
    methods:{

        dynamicFilter(selfObjectParam, filter, event){

            let checked = event.target.checked

            if(!checked) return this[selfObjectParam] = null
            return this[selfObjectParam] = filter
        },


        getUserPetsAndProdjects(type = 'pets'){
            if (!this.user) return

            let url = `/api/user/pets-list`


            if(type === 'projects') url = `/api/user/projects-list`

            axios(url)
                .then(response => {
                    response = response.data

                    if(response.success){
                        if(type === 'projects') return this.userProjects = response.data
                        this.userPets = response.data
                    }

                })
                .catch()

        },

        refreshList(){
            this.getFacilities(true)
        },


        paginateClickCallback(pageNum) {
            this.page = pageNum;

            paginationScrollTo('.facilities__grid')

            this.getFacilities();
        },

        getFacilities(resetPage){
            let url = `/api/facilities`

            if(resetPage){
                this.page = 1
            }


            axios(url, {
                params: {
                    page: this.page,
                    type: this.types.length === 1 ? this.types[0] : null,
                    types: this.types.length > 1  ? this.types : this.types.length === 1 ? null : this.standardTypes,
                    city_id: this.searchBy === 'city' ? this.selectedLocationId : null,
                    region_id: this.searchBy === 'region' ? this.selectedLocationId : null,
                    charge_category: this.chargeCategory,
                    range: this.range,
                    per_page: 5,
                }
            })
                .then(response => {
                    response = response.data

                    if(response.success){
                        this.list = response.data
                        this.page = response.meta.current_page
                        this.pageCount = response.meta.last_page


                    }

                })
                .catch(error => {
                    error = error.response.data

                    console.log(error)

                })


        },

        setCityId(location) {
            this.selectedLocationId = location.id;
            this.locationSearch = location.name;
            this.locationSelected = location.name;
            this.searchBy = location.type;
            this.locationItems = [];
        },

        searchLocations() {
            let self = this;
            let url = `/api/locations`,
                params = {
                    city_id: null,
                    region_id: null,
                    country_id: null,
                    query: self.locationSearch
                }

            axios.get(url, {params: params})
                .then(response => {
                    response = response.data;
                    if (response.success) {

                        self.locationItems = response.data



                    }
                })
                .catch((error) => {

                    error = error.response.data

                    console.log(error)

                    alert(this.$store.getters.t('common_error_reload'));
                })
        },


        sidebarFilterToggle(){
            let productFilter = document.querySelector('.product--sidebar');
            let body = document.querySelector('body');
            productFilter.classList.toggle('product-sidebar--open');
            body.classList.toggle('product-sidebar--open');
        },

        filterToggle(e){
            if(window.matchMedia("min-width: 992px").matches) return

            let filterWrapper = document.querySelector('.product--sidebar-wrapper');
            let filterBtn = document.getElementById('sidebar-toggle');

            if(!filterWrapper.contains(e.target) && !filterBtn.contains(e.target)){
                let productFilter = document.querySelector('.product--sidebar');
                let body = document.querySelector('body');

                productFilter.classList.remove('product-sidebar--open');
                body.classList.remove('product-sidebar--open');
                return;

            }

        }


    }

}
</script>

<style lang="scss" scoped>

.facilities{


}

</style>
